import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@/components/ComingSoon";

export const Route = createFileRoute("/_authed/claims")({
  component: () => (
    <ComingSoon
      title="Claims"
      phase="Phase 6"
      summary="QR claim tokens by status (issued / opened / submitted / expired)."
    />
  ),
});
